import { useTranslation } from 'react-i18next';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyMuiButton } from '~/legacy-components/LegacyForms';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { OtherContactEditMode } from './components/OtherContactEditMode';
import { OtherContactReadMode } from './components/OtherContactReadMode';
import { useOtherContract } from './useOtherContact';

export const OtherContact = () => {
  const {
    empData,
    register,
    errors,
    onSubmit,
    readMode,
    setReadMode,
    countriesList,
    deleteContact,
    control,
    handleFormReset,
    isLoading,
  } = useOtherContract();
  const { t } = useTranslation();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <LegacyHeadingWithActions heading={t('laOtherContact')}>
        {!readMode ? (
          <>
            <LegacyMuiButton
              onClick={deleteContact}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Delete} />}
            >
              {t('laClear')}
            </LegacyMuiButton>
            <LegacyMuiButton
              onClick={onSubmit}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Save} />}
            >
              {t('laSave')}
            </LegacyMuiButton>
            <LegacyMuiButton
              onClick={() => handleFormReset(false)}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Close} />}
            >
              {t('laCancel')}
            </LegacyMuiButton>
          </>
        ) : (
          <>
            <LegacyMuiButton
              onClick={() => setReadMode(false)}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Edit} />}
            >
              {t('laEdit')}
            </LegacyMuiButton>
          </>
        )}
      </LegacyHeadingWithActions>
      {readMode === true ? (
        <OtherContactReadMode data={empData} countryList={countriesList} />
      ) : (
        <OtherContactEditMode
          data={empData}
          register={register}
          errors={errors}
          countryList={countriesList}
          control={control}
        />
      )}
    </>
  );
};
